import {
  extractErrorMessage,
  extractErrorDescription,
  reportErrorToSentry,
  shouldLogError,
  ErrorType,
} from "@/utils/error";
import type { PushAlertPayload } from "@/store/alertReducer";
export interface HandleApiErrorOptions {
  autoClose?: boolean;
  reportToSentry?: boolean;
  context?: Record<string, any>;
}

/**
 * 統一的 API Error 處理函數
 * @param error - Error 物件
 * @param appDispatch - Redux dispatch 物件
 * @param fallbackMessage - 當無法從錯誤中提取訊息時使用的備用訊息
 * @param options - 選項：autoClose, reportToSentry, context
 */

export const handleApiError = (
  error: unknown,
  appDispatch: {
    pushAlert: (payload: PushAlertPayload) => void;
  },
  fallbackMessage?: string,
  options?: HandleApiErrorOptions,
) => {
  const { autoClose = true, reportToSentry = true, context } = options || {};

  // 已中止的請求不處理
  if (!shouldLogError(error)) {
    return;
  }

  // 提取錯誤訊息
  const errorMessage = extractErrorMessage(error, fallbackMessage);
  const errorDescription = extractErrorDescription(error);

  // 顯示錯誤提示
  appDispatch.pushAlert({
    type: "error",
    title: errorMessage,
    desc: errorDescription,
    autoClose,
  });

  // 記錄錯誤到控制台（僅在非正式環境）
  if (shouldLogError(error) && !import.meta.env.PROD) {
    console.error("API Error:", error);
  }

  // 報告錯誤到 Sentry
  if (reportToSentry) {
    reportErrorToSentry(error, context, ErrorType.API_ERROR);
  }
};
